import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function QualificationSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="w-full py-24 px-6 bg-[#0D0D0D]" data-id="element-90">
      <div className="max-w-3xl w-full mx-auto space-y-16" data-id="element-91">
        {/* ESTO ES PARA TI SI... */}
        <div className="space-y-8" data-id="element-92">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-93">
            <span className="text-[#D4A853] text-xs md:text-sm tracking-[0.2em] uppercase font-medium" data-id="element-94">
              ESTO ES PARA TI SI...
            </span>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="space-y-5" data-id="element-95">
            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-96">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-97">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-98" />
              </div>
              <div data-id="element-99">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-100">
                  <span className="font-medium" data-id="element-101">
                    Sientes que «tienes todo», pero no sientes nada.
                  </span>{' '}
                  <span className="text-[#A89F91]" data-id="element-102">
                    Sabes que deberías estar agradecida, pero el vacío interno
                    es real.
                  </span>
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-103">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-104">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-105" />
              </div>
              <div data-id="element-106">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-107">
                  <span className="font-medium" data-id="element-108">Operas en modo respuesta.</span>{' '}
                  <span className="text-[#A89F91]" data-id="element-109">
                    Tu día consiste en apagar incendios ajenos mientras tus
                    propios deseos están en pausa indefinida.
                  </span>
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-110">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-111">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-112" />
              </div>
              <div data-id="element-113">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-114">
                  <span className="font-medium" data-id="element-115">
                    Tu cuerpo envía señales de auxilio.
                  </span>{' '}
                  <span className="text-[#A89F91]" data-id="element-116">
                    Despiertas cansada, tienes neblina mental y el café ya no es
                    suficiente.
                  </span>
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-117">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-118">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-119" />
              </div>
              <div data-id="element-120">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-121">
                  <span className="font-medium" data-id="element-122">Eres una mujer de acción.</span>{' '}
                  <span className="text-[#A89F91]" data-id="element-123">
                    Buscas un manual práctico de 15 minutos al día, no teoría
                    espiritual compleja.
                  </span>
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>

        {/* Divider */}
        <motion.div initial={{
        scaleX: 0,
        opacity: 0
      }} whileInView={{
        scaleX: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#333] to-transparent" data-id="element-124" />

        {/* ESTO NO ES PARA TI SI... */}
        <div className="space-y-8" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-126">
            <span className="text-[#A89F91] text-xs md:text-sm tracking-[0.2em] uppercase font-medium" data-id="element-127">
              ESTO NO ES PARA TI SI...
            </span>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="space-y-5" data-id="element-128">
            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-129">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-130">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-133">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-134">
                    Buscas una «píldora mágica».
                  </span>{' '}
                  Sin el compromiso de 15 minutos diarios, no habrá reinicio.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-135">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-136">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-139">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-140">
                    Prefieres el victimismo.
                  </span>{' '}
                  Si no estás lista para retomar el mando de tus decisiones,
                  esto te resultará confrontativo.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-141">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-142">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-143" />
              </div>
              <div data-id="element-144">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-145">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-146">
                    Buscas tratados de psicología.
                  </span>{' '}
                  Esto es un protocolo operativo de implementación rápida, no un
                  análisis de tu infancia.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-147">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-148">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-149" />
              </div>
              <div data-id="element-150">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-151">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-152">
                    Glorificas el «estar ocupada».
                  </span>{' '}
                  Si no estás dispuesta a soltar el caos, este libro no es para
                  ti.
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}